import { connect } from 'react-redux';

import { IGetArticlesApiParam, ITagPayload } from '@common/domain/models/Article';
import { fetchArticles, fetchTags } from '@common/redux/content/actions';
import { fetchCountMapSelector, fetchTagsLoaderSelector, fetchTagsSelector, getContentTypeMapSelector } from '@common/redux/content/selectors';

import LibraryHome from "@presentation/Content/LibraryHome";

export const mapStateToProps = (state: any) => {
  return {
    tags: fetchTagsSelector(state),
    tagsLoader: fetchTagsLoaderSelector(state),
    countMap: fetchCountMapSelector(state),
    contentTypeMap: getContentTypeMapSelector(state),
  };
};

export const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchTags: (payload: ITagPayload) => dispatch(fetchTags(payload)),
    getDashboardContentList: (params: IGetArticlesApiParam) => dispatch(fetchArticles(params))
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(LibraryHome);


